import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function CompetitorMerch({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({
    suppression: false,
    competitor_qrs_door_hangers: false,
    promotional_standee: false,
  });


  const COMPETITOR_QRS_DOOR_HANGERS = [
    // { name: "GCash - SQR Standee", field: "gcash_sqr_standee" },
    { name: "GCash - Door Hanger", field: "gcash_door_hanger" },
    // { name: "Shopee - SQR Standee", field: "shopee_sqr_standee" },
    { name: "Shopee - Door Hanger", field: "shopee_door_hanger" },
    // { name: "BDO - SQR Standee", field: "bdo_sqr_standee" },
    { name: "BDO - Door Hanger", field: "bdo_door_hanger" },
    // { name: "Atome - SQR Standee", field: "atome_sqr_standee" },
    { name: "Atome - Door Hanger", field: "atome_door_hanger" },
    { name: "Metrobank - Door Hanger", field: "metrobank_door_hanger" }
  ];


  const PROMOTIONAL_STANDEES = [
    { name: "GCash Counterl Standee (Generic)", field: "gcash_counterl_standee" },
    { name: "GCash Countertop Standee (w/ Heart Evangelista)", field: "gcash_promotional_standee_heart" },
    { name: "GCash Heart Evangelista Life Size Standee", field: "gcash_heart_life_size_standee" },
    { name: "Shopee Counter top Standee", field: "shopee_counter_top_standee" },
    { name: "BDO Counter top Standee", field: "bdo_counter_top_standee" },
    { name: "Atome Counter top Standee", field: "atome_counter_top_standee" },
    { name: "Metrobank Counter top Standee", field: "metrobank_counter_top_standee" }
  ];

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === "checkbox" || type === "radio") {
      setPrimaryDetails(prev => ({
        ...prev,
        [name]: type === "radio" ? value : checked
      }));
    } else {
      setPrimaryDetails(prev => ({
        ...prev,
        [name]: value
      }));
    }
    
    // Clear error when user makes a selection
    if (isError[name]) {
      setIsError(prev => ({
        ...prev,
        [name]: false
      }));
    }
  };

  const validateForm = () => {
    const errors = {};
    

    // if (!primaryDetails.suppression) {
    //   errors.suppression = true;
    //   toast.error("Please select a suppression option", {
    //     autoClose: 3000,
    //     hideProgressBar: true,
    //     theme: "colored",
    //   });
    // }

    // Validate Competitor QRs + Door Hangers
    COMPETITOR_QRS_DOOR_HANGERS.forEach(item => {
      if (!primaryDetails[item.field]) {
        errors[item.field] = true;
      }
    });
    if (COMPETITOR_QRS_DOOR_HANGERS.some(item => !primaryDetails[item.field])) {
      toast.error("Please select an option for all Competitor QRs + Door Hangers", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
    }

    // Validate Promotional Standees
    PROMOTIONAL_STANDEES.forEach(item => {
      if (!primaryDetails[item.field]) {
        errors[item.field] = true;
      }
    });
    if (PROMOTIONAL_STANDEES.some(item => !primaryDetails[item.field])) {
      toast.error("Please select an option for all Promotional Standees", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
    }

    setIsError(errors);
    return Object.keys(errors).length === 0;
  };

  const isFormValid = () => {
    // Check if all required fields are filled
    const hasCompetitorSelection = COMPETITOR_QRS_DOOR_HANGERS.every(item => primaryDetails[item.field]);
    const hasPromotionalSelection = PROMOTIONAL_STANDEES.every(item => primaryDetails[item.field]);
    
    return hasCompetitorSelection && hasPromotionalSelection;
  };
  const handleNext = () => {
    if (validateForm()) {
   
      navigation.go("merchant-other-solution");
    }
  };

  const handleBack = () => {
     navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">

          {/* Main Form */}
          <Col md={10}>
              <div className="form-main-header">
                <h4 className="form-title">
                  COMPETITOR MERCH
                </h4>
                <p className="form-desc">
                  Section 65 of 110
                </p>
              </div>
              <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">
                  {/* Suppression Section */}
                  {/* <Form.Group className="mb-5" controlId="suppression">
                    <Form.Label className="form-label">
                      Suppression <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {["Yes", "No"].map((option, index) => (
                        <div
                          key={`suppression-${index}`}
                          className={`form-radio-item${primaryDetails.suppression === option ? " selected" : ""}`}
                        >
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              id={`suppression-${index}`}
                              name="suppression"
                              value={option}
                              label={option}
                              checked={primaryDetails.suppression === option}
                              onChange={handleInputChange}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    
                    {isError.suppression && (
                      <div className="form-error">Please select a suppression option</div>
                    )}
                  </Form.Group> */}

                  {/* Competitor QRs + Door Hangers Section */}
                  <Form.Group className="mb-5" controlId="competitor_qrs_door_hangers">
                    <Form.Label className="form-label">
                      Promotional Door Hanger <span className="form-required">*</span>
                    </Form.Label>

                    {/* Header Row */}
                    <div className="competitor-grid-header">
                      <div>Item</div>
                      <div className="text-center">VISIBLE</div>
                      {/* <div className="text-center">QR STANDEE</div> */}
                      <div className="text-center">NONE</div>
                    </div>

                    {/* Competitor Items */}
                    {COMPETITOR_QRS_DOOR_HANGERS.map((item, index) => (
                      <div key={index} className="competitor-grid-row">
                        <div className="grid-item-name">{item.name}</div>
                        <div className="text-center">
                          <Form.Check
                            type="radio"
                            name={item.field}
                            value="generic_qrph"
                            checked={primaryDetails[item.field] === "generic_qrph"}
                            onChange={handleInputChange}
                          />
                        </div>
                        {/* <div className="text-center">
                          <Form.Check
                            type="radio"
                            name={item.field}
                            value="qr_standee"
                            checked={primaryDetails[item.field] === "qr_standee"}
                            onChange={handleInputChange}
                          />
                        </div> */}
                        <div className="text-center">
                          <Form.Check
                            type="radio"
                            name={item.field}
                            value="none"
                            checked={primaryDetails[item.field] === "none"}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    ))}
                  </Form.Group>

                  {/* Promotional Standee Section */}
                  <Form.Group className="mb-5" controlId="promotional_standee">
                    <Form.Label className="form-label">
                      Promotional Standee <span className="form-required">*</span>
                    </Form.Label>

                    {/* Header Row */}
                    <div className="promo-grid-header">
                      <div>Promotional Standee</div>
                      <div className="text-center">Yes</div>
                      <div className="text-center">No</div>
                    </div>

                    {/* Promotional Standees */}
                    {PROMOTIONAL_STANDEES.map((standee, index) => (
                      <div key={index} className="promo-grid-row">
                        <div className="grid-item-name">{standee.name}</div>
                        <div className="text-center">
                          <Form.Check
                            type="radio"
                            name={standee.field}
                            value="yes"
                            checked={primaryDetails[standee.field] === "yes"}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div className="text-center">
                          <Form.Check
                            type="radio"
                            name={standee.field}
                            value="no"
                            checked={primaryDetails[standee.field] === "no"}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    ))}
                  </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                   Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CompetitorMerch;
